document.addEventListener('algolia.hooks.initialize', function () {
    algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function(_defaultTemplate, html, item) {
        // Skip rendering if the item has the "Test Product" tag
        if (item.tags && item.tags.includes('Test Product')) {
            return null; // Return null to prevent rendering this item
        }
    
        // Calculate ratio for aspect ratio (matching DAWN logic)
        let ratio = 1;
        if (item.product_image && '' == 'portrait') {
            ratio = 0.8;
        } else if (item.product_image && '' == 'adapt') {
            // You might need to pass aspect ratio data from your Algolia index
            ratio = item.image_aspect_ratio || 1;
        }
        if (ratio == 0 || ratio == null) {
            ratio = 1;
        }
    
        return html`
            <div class="card-wrapper product-card-wrapper underline-links-hover" data-handle="${item.handle}" data-variant-id="${item.objectID}">
                <div
                    class="
                        card card--card
                        ${item.product_image ? 'card--media' : 'card--text'}
                         color-scheme-0996e2a3-9bbe-49c1-8f13-f09c49aaf970 gradient
                        
                        card--extend-height
                        ${!item.product_image && 'card' == 'card' ? 'ratio' : ''}
                    "
                    style="--ratio-percent: ${100 / ratio}%;"
                    data-algolia-index="${item.index}"
                    data-algolia-position="${item.productPosition}"
                    data-algolia-queryid="${item.queryID}"
                    data-algolia-objectid="${item.objectID}"
                    data-handle="${item.handle}"
                    data-variant-id="${item.objectID}"
                    data-distinct="${item._distinct}"
                    data-product-id="${item.id}"
                >
                    <div
                        class="card__inner ${item.product_image || 'card' == 'standard' ? ' ratio' : ''}"
                        style="--ratio-percent: ${100 / ratio}%;"
                    >
                        ${item.product_image ? html`
                            <div class="card__media">
                                <div class="media media--transparent media--hover-effect">
                                    <img
                                        src="${item.product_image}"
                                        alt="${item.title}"
                                        class="motion-reduce"
                                        loading="lazy"
                                        style="width:100%"
                                    />
                                    ${item.product_image_alt ? html`
                                        <img
                                            src="${item.product_image_alt}"
                                            alt="${item.title}"
                                            class="motion-reduce"
                                            loading="lazy"
                                            style="width:100%"
                                        />
                                    ` : ''}
                                </div>
                            </div>
                        ` : ''}
                        
                        <div class="card__content">
                            <div class="card__information">
                                <h3
                                    class="card__heading"
                                    ${!item.product_image && 'card' == 'standard' ? `id="title--${item.id}"` : ''}
                                >
                                    <a
                                        href="/products/${item.handle}"
                                        id="StandardCardNoMediaLink--${item.id}"
                                        class="full-unstyled-link"
                                        aria-labelledby="StandardCardNoMediaLink--${item.id} NoMediaStandardBadge--${item.id}"
                                        
                                        title="${item.title}"
                                    >
                                        ${item.title}
                                    </a>
                                </h3>
                            </div>
                            <div class="card__badge top left">
                                ${item.tags && item.tags.includes("Sale") ? html`
                                    <span
                                        id="NoMediaStandardBadge--${item.id}"
                                        class="badge badge--bottom-left color-scheme-8e9407be-d0f3-4623-9f58-ba0c7f277178"
                                    >
                                        Sale
                                    </span>
                                ` : ''}
                            </div>
                        </div>
                        
                        <!-- Swym Wishlist Plus EPI Button -->
                        <button
                            aria-label="Add to Wishlist"
                            data-with-epi="true"
                            class="swym-button swym-add-to-wishlist-view-product product_${item.id}"
                            data-swaction="addToWishlist"
                            data-product-id="${item.id}"
                            data-variant-id="${item.objectID}"
                            data-product-url="https://medicalrite.com/products/${item.handle}"
                        ></button>
                        <div class="quick-add quick-view no-js-hidden custom-quick-add-modal">
                            <modal-opener data-modal="#QuickAdd-${item.id}">
                                <button
                                    id="quick-add-${item.id}-submit"
                                    type="submit"
                                    name="add"
                                    class="quick-add__submit button button--full-width button"
                                    aria-haspopup="dialog"
                                    aria-labelledby="quick-add-${item.id}-submit title-${item.id}"
                                    data-product-url="/products/${item.handle}"
                                    data-product-id="${item.id}"
                                >
                                    <svg class="plus_icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_198_2016)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.88281 1.52002C6.88281 0.967735 6.43509 0.52002 5.88281 0.52002C5.33053 0.52002 4.88281 0.967735 4.88281 1.52002V5H1.40234C0.850059 5 0.402344 5.44771 0.402344 6C0.402344 6.55228 0.850059 7 1.40234 7H4.88281V10.48C4.88281 11.0323 5.33053 11.48 5.88281 11.48C6.43509 11.48 6.88281 11.0323 6.88281 10.48V7H10.3623C10.9146 7 11.3623 6.55228 11.3623 6C11.3623 5.44771 10.9146 5 10.3623 5H6.88281V1.52002Z" fill="white"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_198_2016">
                                        <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <span>Quick View</span>
                                    <div class="loading__spinner hidden">
                                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </button>
                            </modal-opener>
                            <quick-add-modal id="QuickAdd-${item.id}" class="quick-add-modal">
                                <div
                                    role="dialog"
                                    aria-label="Choose options for "
                                    aria-modal="true"
                                    class="quick-add-modal__content global-settings-popup"
                                    tabindex="-1"
                                >
                                    <button
                                        id="ModalClose-${item.id}"
                                        type="button"
                                        class="quick-add-modal__toggle"
                                        aria-label="Close"
                                    >
                                        <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                            <path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>
                                        </svg>
                                    </button>
                                    <div id="QuickAddInfo-${item.id}" class="quick-add-modal__content-info"></div>
                                </div>
                            </quick-add-modal>
                        </div>
                    </div>
                    
                    <div class="card__content">
                        <div class="card__information">
                            <div class="card-information">
                                <div class="vendor-rating-wrapper">
                                    <!-- Vendor Display -->
                                    ${item.vendor == 'Dealmed' ? html`
                                        <div class="original_brand">
                                            <div class="original-img-wrap">
                                                <img src="//medicalrite.com/cdn/shop/files/dealmed_1467578e-105d-4b78-b98c-ab6d8d28949b.png?v=1716913682&width=16" 
                                                    loading="lazy" 
                                                    class="dealmed-vendor-logo" 
                                                    alt="Dealmed Logo" />
                                            </div>
                                            <div class="original_text">Original</div>
                                        </div>
                                    ` : html`
                                        <span class="productitem--vendor">
                                            <a>${item.vendor}</a>
                                        </span>
                                    `}
                                    
                                    <div class="custom_separator">|</div>
                                    
                                    <!-- Okendo Rating -->
                                    ${item.meta?.okendo?.StarRatingSnippet ? html`
                                        <div data-oke-star-rating 
                                            data-oke-reviews-product-id="shopify-${item.id}"
                                            dangerouslySetInnerHTML=${createHTML(item.meta.okendo.StarRatingSnippet)}></div>
                                    ` : ''}
                                </div>
                                
                                <h3
                                    class="card__heading${item.product_image || 'card' == 'standard' ? ' h5' : ''}"
                                    ${item.product_image || 'card' == 'card' ? `id="title--${item.id}"` : ''}
                                >
                                    <a
                                        href="/products/${item.handle}"
                                        id="CardLink--${item.id}"
                                        class="full-unstyled-link"
                                        aria-labelledby="CardLink--${item.id} Badge--${item.id}"
                                        
                                        title="${item.title}"
                                    >
                                        ${item.title}
                                        ${item.options?.sold_by && item.options.sold_by !== "Single Piece" && item.options.sold_by !== "each" && item.options.sold_by !== "ea" ? 
                                            html`, <span class="title-sub-variant">${item.options.sold_by}</span>` : ''}
                                    </a>
                                </h3>
                                
                                <!-- Price Section -->
                                <div class="price ${item.variants_compare_at_price_min > item.variants_min_price ? html `price--on-sale ` : ''} price--show-badge">
                                    <div class="price__container">
                                        <div class="price__regular">
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            ${item.variants_count !== 1 ? html`
                                                <div class="price-item">
                                                    <span class="price__from">From</span>
                                                    <span class="price-item price-item--regular">
                                                        <span class="money">${algoliaShopify.helpers.displayPrice({price: item.variants_min_price}, item._distinct)}</span>
                                                    </span>
                                                </div>
                                                ` : 
                                                html`
                                                <span class="price-item price-item--regular">
                                                        <span class="money">${algoliaShopify.helpers.displayPrice({price: item.variants_min_price}, item._distinct)}</span>
                                                </span>
                                            `}

                                        </div>
                                        ${item.variants_compare_at_price_min && item.variants_compare_at_price_min > item.variants_min_price ? html`
                                            <div class="price__sale">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span>
                                                    <s class="price-item price-item--regular">${algoliaShopify.helpers.displayStrikedPrice(item.variants_min_price, item.variants_compare_at_price_min)}</s>
                                                </span>
                                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                <span class="price-item price-item--sale price-item--last">
                                                    ${item.variants_count !== 1 ? html`<span class="price__from">From</span>` : ''}
                                                    <span class="money">${algoliaShopify.helpers.displayPrice({price : (item.variants_min_price)}, item._distinct)}</span>
                                                </span>
                                            </div>
                                        ` : ''}
                                            
                                    </div>
                                        
                                    ${(() => {
                                        if (item.variants_compare_at_price_min && item.variants_min_price) {
                                            const minDiscount = Math.round((item.variants_compare_at_price_min - item.variants_min_price) / item.variants_compare_at_price_min * 100);
                                            const maxDiscount = item.variants_compare_at_price_max && item.variants_max_price ? 
                                                Math.round((item.variants_compare_at_price_max - item.variants_max_price) / item.variants_compare_at_price_max * 100) : 0;
                                            const highestDiscount = Math.max(minDiscount, maxDiscount);
                                            
                                            return highestDiscount > 0 ? html`
                                                <span class="badge price__badge-save color-scheme-57979acc-2cf0-4397-9127-0a007ae8bd0c">
                                                    Save ${highestDiscount}%
                                                </span>
                                            ` : '';
                                        }
                                        return '';
                                    })()}
                                </div>
                            </div>
                        </div>
                        

                        <div class="quick-add no-js-hidden">
                            ${item.variants_count > 1 ? html`
                                <modal-opener data-modal="#QuickAdd-${item.id}">
                                    <button
                                        id="quick-add-${item.id}-submit"
                                        type="submit"
                                        name="add"
                                        class="quick-add__submit button button--full-width button"
                                        aria-haspopup="dialog"
                                        aria-labelledby="quick-add-${item.id}-submit title-${item.id}"
                                        data-product-url="/products/${item.handle}"
                                        data-product-id="${item.id}"
                                    >
                                        Add to cart
                                        <div class="loading__spinner hidden">
                                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                            </svg>
                                        </div>
                                    </button>
                                </modal-opener>
                                <quick-add-modal id="QuickAdd-${item.id}" class="quick-add-modal">
                                    <div
                                        role="dialog"
                                        aria-label="Choose options for "
                                        aria-modal="true"
                                        class="quick-add-modal__content global-settings-popup"
                                        tabindex="-1"
                                    >
                                        <button
                                            id="ModalClose-${item.id}"
                                            type="button"
                                            class="quick-add-modal__toggle"
                                            aria-label="Close"
                                        >
                                            <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                                <path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>
                                            </svg>
                                        </button>
                                        <div id="QuickAddInfo-${item.id}" class="quick-add-modal__content-info"></div>
                                    </div>
                                </quick-add-modal>
                            ` : html`
                                <algolia-product-form data-section-id="algolia-${item.id}">
                                    <form action="/cart/add" method="post" enctype="multipart/form-data" class="form" novalidate="novalidate" data-type="add-to-cart-form" id="product-form-${item.id}">
                                        <input type="hidden" name="id" value="${item.objectID}" class="product-variant-id" />
                                        <button
                                            id="ProductSubmitButton-${item.id}"
                                            type="submit"
                                            name="add"
                                            class="quick-add__submit button button--full-width button"
                                            aria-labelledby="ProductSubmitButton-${item.id} title-${item.id}"
                                            aria-live="polite"
                                            data-sold-out-message="true"
                                        >
                                            <span>Add to cart</span>
                                            <span class="sold-out-message hidden">Sold out</span>
                                            <div class="loading__spinner hidden">
                                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                                </svg>
                                            </div>
                                        </button>
                                    </form>
                                </algolia-product-form>
                            `}
                        </div>
                        <div class="view-full-product-link-wrapper">
                            <a href="/products/${item.handle}" class="link product__view-details animate-arrow large-hide">
                                View Full Product
                            </a>
                        </div>
                        <div class="card__badge top left">
                            ${!item.available ? html`
                                <span
                                    id="Badge--${item.id}"
                                    class="badge badge--bottom-left color-scheme-3"
                                >
                                    Sold out
                                </span>
                            ` : (item.variants_compare_at_price_min > item.variants_min_price && item.available) ? html`
                                <span
                                    id="Badge--${item.id}"
                                    class="badge badge--bottom-left color-scheme-8e9407be-d0f3-4623-9f58-ba0c7f277178"
                                >
                                    Sale
                                </span>
                            ` : ''}
                        </div>
                    </div>
                </div>
            </div>
        `;
    });
});

document.addEventListener('DOMContentLoaded', function() {
    
    // Custom ProductForm class for Algolia elements
    class AlgoliaProductForm extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.form = this.querySelector('form');
            if (!this.form) return;
            
            this.variantIdInput = this.form.querySelector('[name=id]');
            if (this.variantIdInput) {
                this.variantIdInput.disabled = false;
            }
            
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
            this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        }
    
        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
            if (this.submitButton) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
            }
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.remove('hidden');
        
            // Use the same config as DAWN's product-form.js
            let config;
            if (typeof fetchConfig === 'function') {
                config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type']; // Let browser set it for FormData
            } else {
                // Fallback if fetchConfig not available
                config = {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                };
            }
        
            const formData = new FormData(this.form);
        
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }
        
            config.body = formData;
        
            // Use routes global if available
            const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        
            fetch(cartUrl, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
        
                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButtonText.classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = (window.routes && window.routes.cart_url) || '/cart';
                        return;
                    }
        
                    this.error = false;
                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                        document.body.addEventListener(
                            'modalClosed',
                            () => {
                                setTimeout(() => {
                                    this.cart.renderContents(response);
                                });
                            },
                            { once: true }
                        );
                        quickAddModal.hide(true);
                    } else {
                        this.cart.renderContents(response);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.handleErrorMessage('Unable to add to cart');
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    if (spinner) spinner.classList.add('hidden');
                });
        }
    
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    }

    // Custom QuickAddModal class for Algolia elements  
    class AlgoliaQuickAddModal extends HTMLElement {
        constructor() {
            super();
            
            // Add event listeners like DAWN's ModalDialog
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
            
            this.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') this.hide();
            });
        }

        connectedCallback() {
            // Auto-move to body like DAWN's ModalDialog
            if (this.moved) return;
            this.moved = true;
            
            // Find the closest section for dataset (similar to DAWN)
            const section = this.closest('.shopify-section');
            if (section) {
                this.dataset.section = section.id.replace('shopify-section-', '');
            }
            
            document.body.appendChild(this);
            
            // Initialize modal content area
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            
            // Add close button listener
            const closeBtn = this.querySelector('[id^="ModalClose-"]');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.hide());
            }
        }

        show(opener) {
            if (!opener) return;
            
            this.openedBy = opener;
            
            opener.setAttribute('aria-disabled', true);
            opener.classList.add('loading');
            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.remove('hidden');
        
            fetch(opener.getAttribute('data-product-url'))
                .then((response) => response.text())
                .then((responseText) => {
                    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                    const productElement = responseHTML.querySelector('product-info');
                    
                    if (productElement && this.modalContent) {
                        this.preprocessHTML(productElement);
                        
                        // Use DAWN's HTMLUpdateUtility instead of innerHTML
                        if (window.HTMLUpdateUtility) {
                            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
                        } else {
                            this.modalContent.innerHTML = productElement.outerHTML;
                        }
                        
                        // CRITICAL: Call initialization after content is set
                        setTimeout(() => {
                            this.initializeModalElements();
                        }, 50);
                    }
                    
                    document.body.classList.add('overflow-hidden');
                    this.setAttribute('open', '');
                    
                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    if (window.ProductModel) window.ProductModel.loadShopifyXR();
                    
                    if (window.trapFocus) {
                        window.trapFocus(this, this.querySelector('[role="dialog"]'));
                    }
                })
                .finally(() => {
                    opener.removeAttribute('aria-disabled');
                    opener.classList.remove('loading');
                    if (spinner) spinner.classList.add('hidden');
                });
        }
        
        // Add the preprocessing method from DAWN's QuickAddModal
        preprocessHTML(productElement) {
            productElement.classList.forEach((classApplied) => {
                if (classApplied.startsWith('color-') || classApplied === 'gradient')
                    this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs(productElement);
            this.removeDOMElements(productElement);
            this.updateImageSizes(productElement);
            this.preventVariantURLSwitching(productElement);
        }
        
        preventVariantURLSwitching(productElement) {
            productElement.setAttribute('data-update-url', 'false');
        }
        
        preventDuplicatedIDs(productElement) {
            const sectionId = productElement.dataset.section;
            const oldId = sectionId;
            const newId = `quickadd-${sectionId}`;
            productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
            Array.from(productElement.attributes).forEach((attribute) => {
                if (attribute.value.includes(oldId)) {
                    productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
                }
            });
            productElement.dataset.originalSection = sectionId;
        }
        
        removeDOMElements(productElement) {
            const pickupAvailability = productElement.querySelector('pickup-availability');
            if (pickupAvailability) pickupAvailability.remove();
        
            const productModal = productElement.querySelector('product-modal');
            if (productModal) productModal.remove();
        
            const modalDialog = productElement.querySelectorAll('modal-dialog');
            if (modalDialog) modalDialog.forEach((modal) => modal.remove());
        }
        
        updateImageSizes(productElement) {
            const product = productElement.querySelector('.product');
            const desktopColumns = product?.classList.contains('product--columns');
            if (!desktopColumns) return;
        
            const mediaImages = product.querySelectorAll('.product__media img');
            if (!mediaImages.length) return;
        
            let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        
            if (product.classList.contains('product--medium')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '605px');
            } else if (product.classList.contains('product--small')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '495px');
            }
        
            mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
        }
        
        initializeModalElements() {
            // Initialize product forms with cart drawer behavior
            const productForms = this.modalContent.querySelectorAll('product-form');
            productForms.forEach(form => {
                if (customElements.get('product-form')) {
                    customElements.upgrade(form);
                    
                    // Override form submission to close modal after cart update
                    const originalSubmitHandler = form.onSubmitHandler;
                    if (originalSubmitHandler) {
                        form.onSubmitHandler = (evt) => {
                            const result = originalSubmitHandler.call(form, evt);
                            
                            // Close modal after successful cart addition
                            document.body.addEventListener('modalClosed', () => {
                                this.hide(true);
                            }, { once: true });
                            
                            return result;
                        };
                    }
                }
            });
            
            // Initialize other components
            const variantSelects = this.modalContent.querySelector('variant-selects');
            if (variantSelects && customElements.get('variant-selects')) {
                customElements.upgrade(variantSelects);
            }
            
            const productInfo = this.modalContent.querySelector('product-info');
            if (productInfo && customElements.get('product-info')) {
                customElements.upgrade(productInfo);
            }
            
            const sliders = this.modalContent.querySelectorAll('slider-component');
            sliders.forEach(slider => {
                if (customElements.get('slider-component')) {
                    customElements.upgrade(slider);
                }
            });
        }

        hide(preventFocus = false) {
            document.body.classList.remove('overflow-hidden');
            document.body.dispatchEvent(new CustomEvent('modalClosed'));
            this.removeAttribute('open');
            
            if (this.modalContent) {
                this.modalContent.innerHTML = '';
            }
            
            // Remove focus trap like DAWN
            if (window.removeTrapFocus && this.openedBy && !preventFocus) {
                window.removeTrapFocus(this.openedBy);
            }
            
            if (window.pauseAllMedia) {
                window.pauseAllMedia();
            }
        }
    }

    // Define custom elements only once
    if (!customElements.get('algolia-product-form')) {
        customElements.define('algolia-product-form', AlgoliaProductForm);
    }
    if (!customElements.get('quick-add-modal')) {
        customElements.define('quick-add-modal', AlgoliaQuickAddModal);
    }

    // Function to initialize event listeners
    function initializeAlgoliaElements() {
        console.log('Initializing Algolia elements...');
        
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        hideCurrentProductSlide(current_product_handle);
        // Handle modal openers (modals auto-move to body via connectedCallback)
        document.querySelectorAll('.uic-HorizontalSlider-list modal-opener:not([data-algolia-ready])').forEach(opener => {
            opener.setAttribute('data-algolia-ready', 'true');
            
            const button = opener.querySelector('button');
            // alert('1')
            if (button) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    const modalId = opener.getAttribute('data-modal');
                    const modal = document.querySelector(modalId);
                    if (modal && modal.show) {
                        modal.show(button);
                    }
                });
            }
        });
    }

    function hideCurrentProductSlide(currentProductHandle) {
        // Select all product card wrappers
        const productCards = document.querySelectorAll('.product-card-wrapper');
    
        // Iterate through each product card
        productCards.forEach((card) => {
          // Check if the data-handle matches the current product handle
          if (card.getAttribute('data-handle') === currentProductHandle) {
            // Find the parent li element (slide)
            const slideElement = card.closest('li.uic-HorizontalSlider-item');
    
            // If the slide element is found, hide it
            if (slideElement) {
              slideElement.style.display = 'none';
            }
          }
        });
    }

    // Event listeners
    const observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && // Element node
                        (node.classList?.contains('uic-HorizontalSlider-container') || 
                        node.querySelector?.('.uic-HorizontalSlider-container') ||
                        node.matches?.('[data-quickshop-full]') ||
                        node.querySelector?.('[data-quickshop-full]'))) {
                        shouldReinit = true;
                    }
                });
            }
        });
        
        if (shouldReinit) {
            setTimeout(initializeAlgoliaElements, 100);
        }
    });

    // Observe multiple potential containers - fix this part
    const containers = [
        document.querySelector('.uic-HorizontalSlider-container'),
        document.querySelector('#recommendations'),
        document.querySelector('[data-section-type="product-recommendations"]'),
        document.body // fallback
    ].filter(Boolean);

    containers.forEach(container => {
        observer.observe(container, { childList: true, subtree: true });    
    });
    
    setTimeout(initializeAlgoliaElements, 1500);
});


